var segmentedData = {
  name: 'segmented',
  data: [{
    borderColor: '#dee2e6'
  }]
};
export default segmentedData;